import { CancelOutlined } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function PaymentFailed() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("order_id");

  useEffect(() => {
    // If no order_id, redirect to home after a delay
    if (!orderId) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [orderId, navigate]);

  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 80px)",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <Box>
        <CancelOutlined sx={{ fontSize: 80, color: "error.main" }} />
      </Box>

      <Typography fontSize="28px" fontWeight="700" sx={{ mt: 3, mb: 2 }}>
        Payment Failed
      </Typography>

      {orderId && (
        <Typography fontSize="16px" color="text.secondary" sx={{ mb: 2 }}>
          Order ID: <strong>{orderId}</strong>
        </Typography>
      )}

      <Typography fontSize="18px" sx={{ mb: 1, maxWidth: 600 }}>
        Your order has been cancelled.
      </Typography>

      <Typography fontSize="16px" color="text.secondary" sx={{ mb: 4, maxWidth: 600 }}>
        The payment was not completed. Please try again or contact support if you need assistance.
      </Typography>

      <Box sx={{ display: "flex", gap: 2 }}>
        <Button variant="outlined" href="/" size="large">
          Back to Home
        </Button>
        <Button variant="contained" href="/" size="large">
          Browse Events
        </Button>
      </Box>
    </Box>
  );
}
